import React from 'react'
import styled from 'styled-components'
import Loader from 'react-loader-spinner'
import { useMemberSpotlight } from 'hooks/useMemberSpotlight'
import Markdown from 'react-markdown'

const PartnerSpotlight = ({ link }) => {
  const { dataMostRecentMemberSpotlight } = useMemberSpotlight()
  return (
    <PartnerContainer className="m-3 small-font">
      {dataMostRecentMemberSpotlight ? (
        <>
          <p>
            <a href={dataMostRecentMemberSpotlight?.website} target="_blank">
              <img
                src={dataMostRecentMemberSpotlight?.logo}
                alt="Member Spotlight"
              />
            </a>
            <Markdown
              source={dataMostRecentMemberSpotlight?.description}
              linkTarget="_blank"
            />
          </p>
        </>
      ) : (
        <Loader type="ThreeDots" height={30} width={30} color="#bdbdbd" />
      )}

      {link ? (
        <>{link}</>
      ) : (
        <Loader type="ThreeDots" height={30} width={30} color="#bdbdbd" />
      )}
    </PartnerContainer>
  )
}

const PartnerContainer = styled.div`
  img {
    width: 100%;
    margin-bottom: 1rem;
  }

  > p {
    border-bottom: 1px solid black;
    padding-bottom: 1rem;

    &:last-child {
      border-bottom: 0;
    }
  }
`

export default PartnerSpotlight
